var _defs, _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScriptModalBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 518.018 791.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.5,
    cy: 0.5,
    r: 0.622,
    gradientTransform: "matrix(0 -1 .691 0 .154 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#7c5bf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#7f5ff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316,
    stopColor: "#886bef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#977fec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.611,
    stopColor: "#ad9ce9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#c8c0e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    stopColor: "#d6d2e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.928,
    stopColor: "#baade8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.982,
    stopColor: "#8c71f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c5bf5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 961",
    fill: "#bebebe",
    stroke: "gray",
    strokeMiterlimit: 10,
    d: "M.5.5h517.018v790.153H.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 962",
    transform: "rotate(90 244.427 270.983)",
    stroke: "#666",
    strokeMiterlimit: 10,
    fill: "url(#a)",
    d: "M0 0h741.976v512.804H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1174",
    fill: "#fff",
    stroke: "#666",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    id: "close-button",
    "data-name": "Rectangle 963",
    d: "M496.756 4.7h16.096v16.096h-16.096z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1169"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 139",
    d: "m499.234 18.318 11.14-11.14"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 140",
    d: "m499.234 7.178 11.14 11.14"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1172"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 964",
    d: "M473.426 4.7h16.096v16.096h-16.096z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1171"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 965",
    d: "M476.677 7.951h9.594v9.594h-9.594z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 141",
    d: "M476.677 10.455h9.594"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1173"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 966",
    d: "M450.096 4.7h16.097v16.096h-16.097z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 142",
    d: "M452.764 17.545h10.76"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.486 5.161h1.058v1.058H7.486Zm6.348 0h1.058v2.116h-1.057v1.058h4.232V9.39h-6.348v1.058h5.29v1.058h-5.29v1.058h7.406v1.058h-7.406v2.116h6.348V16.8h-6.348v1.058H10.66v1.058H9.602v1.058H8.544v1.058H6.428v1.058H3.254v-1.058h3.174v-1.058h2.116v-1.058h1.058v-1.058h1.058V16.8H4.312v-1.058h6.348v-2.117H3.254v-1.058h7.406v-1.058H5.37v-1.058h5.29V9.39H4.312V8.332h4.232V6.216h1.058v2.116h3.175V7.274h1.058Zm-2.115 12.697h1.058v1.058h-1.058Zm1.058 1.058h2.116v1.058h-2.116Zm2.116 1.058h4.232v1.058h-1.058v1.058h-1.058v-1.058h-2.116ZM29.706 5.161h4.232v1.058h-4.232v1.058h-1.058V9.39h6.348v1.058h-4.232v1.058h-1.058v-1.058h-1.058v3.174h3.174v2.116h-1.058V16.8h3.174v3.174H32.88v1.058h-1.058v1.058h-1.058v-1.058h1.058v-1.058h1.058v-2.116h-3.174v-2.116h1.058v-1.058h-4.233v3.174h-1.058v2.116h-1.058v1.058h-1.061v1.058h-2.113v-1.058h2.113v-1.058h1.058v-2.116h1.058v-3.174h-1.055v-1.059h3.174v-3.174h-1.058v1.058h-1.058v1.058h-1.058v1.058h-2.116v1.058h-2.116v-1.058h2.116v-1.058h2.116v-1.058h1.058v-1.058h-4.232V9.39h6.348V7.274h-5.29V6.216h7.406Zm1.058 6.348h2.116v1.058h-2.116Zm2.116 1.058h3.174v1.058h-1.058v1.058h-1.058v-1.058H32.88Zm-3.174 7.407h1.058v1.058h-1.058ZM41.344 5.161h1.058v2.116h3.174V6.219h1.058v1.058h4.232v1.058h-5.29V9.39h4.232v1.058h-4.231v1.058h4.232v1.058h-4.232v1.058h5.29v1.058h-5.29v1.058h7.406V16.8h-5.29v1.058h-1.058V16.8h-1.058v5.29h-1.059V16.8H43.46v1.058h-1.058v1.058h-1.058v1.058h-2.116v1.058h-2.116v-1.058h2.116v-1.058h2.116v-1.058h1.058V16.8h-5.29v-1.058h3.174V9.39h-1.058v1.058H38.17v1.058h-1.058v-1.058h1.058V9.39h1.058V8.332h1.058V7.274h1.058Zm3.174 0h1.058v1.058h-1.058Zm-3.174 3.174V9.39h3.174V8.332Zm0 2.116v1.058h3.174v-1.058Zm0 2.116v1.058h3.174v-1.058Zm0 2.116v1.058h3.174v-1.057Zm6.348 3.174h1.062v1.058h-1.061Zm1.062 1.059h3.174v1.058h-1.061v1.058h-1.058v-1.058h-1.055Zm6.348-13.755h13.752V22.09H55.099Zm1.052 1.058v14.813h6.348v-1.058h1.062v-1.058h-3.175v1.058h-1.058v-1.058h-2.116v-1.058h6.349V16.8h-6.349v-1.058h4.232v-1.058h-3.174V9.39h3.174V8.332h-4.232V7.274h4.232V6.216Zm6.348 0v1.058h4.232v1.058h-4.228V9.39h3.174v5.29h-3.174v1.058h3.174v-1.054h1.058V16.8h-2.116v1.058h2.116v1.058h-2.116v2.116h3.174V6.219Zm-3.174 4.232v1.058h2.116v-1.058Zm3.174 0v1.058h2.116v-1.058Zm-3.171 2.116v1.058h2.116v-1.058Zm3.174 0v1.058h2.116v-1.058Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScriptModalBg);
export default __webpack_public_path__ + "static/media/script_modal_bg.9683d54d.svg";
export { ForwardRef as ReactComponent };